import React from 'react'
import { GTLLogoWhite } from '../../Components/Images'
import { useLoaded } from '../../Components/useLoaded'

export const GTLRecCashHeroSection = () => {
    const [loaded] = useLoaded()
    return (
        <React.Fragment>
            <section id="rec_cash_hero_section">
                <div className="wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <div className="hero_main">
                                    <p className="para_1">family caregiver support program</p>
                                    <p className="para_2">GTL Recover Cash Product Information</p>
                                    <img src={GTLLogoWhite} alt="HugGraphic" className={"hero_img my_animation " + loaded} />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    )
}
